const getPrescriberFullFax = ({ value, patient, prescriber }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.Fax) {
    return prescriber.Fax.replace('+1 ', '');
  }
  if (patient.Prescriber[0] && patient.Prescriber[0].Fax) {
    return patient.Prescriber[0].Fax.replace('+1 ', '');
  }
  return null;
};

export default getPrescriberFullFax;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberFullFax.js